import { createContext, useContext } from "react";

import {
  ConnectionBaseFragment,
  ConnectionCdcFeaturesFragment,
  useConnectionCdcFeaturesQuery,
} from "@/apollo/types";
import { useIntegration } from "@/integrations";

export const ConnectionFeaturesContext =
  createContext<ConnectionCdcFeaturesFragment | null>(null);

export const useConnectionCDCFeaturesContext = () => {
  const ctx = useContext(ConnectionFeaturesContext);
  if (!ctx) {
    throw new Error(
      "useConnectionFeaturesContext must be used within a ConnectionFeaturesProvider",
    );
  }
  return ctx;
};

const defaultFeatures: ConnectionCdcFeaturesFragment = {
  changeDataCaptureEnabled: false,
  supportedTables: [],
  unsupportedReason: null,
};

export const ConnectionCDCFeaturesProvider = (props: {
  children: React.ReactNode;
  connection: ConnectionBaseFragment;
  sourceSettings?: Record<string, any>;
}) => {
  const sourceIntegration = useIntegration(props.connection.integrationId);

  const cdcSupported =
    sourceIntegration?.eltSource?.changeDataCaptureSupported === true;
  const { data: connectionCDCFeaturesData } = useConnectionCdcFeaturesQuery({
    variables: {
      connectionId: props.connection.id,
      sourceSettings: props.sourceSettings,
    },
    skip: !cdcSupported,
  });

  let features = defaultFeatures;
  if (cdcSupported && connectionCDCFeaturesData?.connectionCDCFeatures) {
    features = connectionCDCFeaturesData.connectionCDCFeatures;
  }
  return (
    <ConnectionFeaturesContext.Provider value={features}>
      {props.children}
    </ConnectionFeaturesContext.Provider>
  );
};
